/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";

// reactstrap components
import {   
    Container,
    Row,
} from "reactstrap";

// core components
import UserHeader from "./Header.js";
import UserPreview from "./UserPreview.js"
import UserData from "./UserData.js"

const Profile = () => {

    return (
        <>
            <UserHeader/>
            {/* Page content */}
            <Container className="mt--7 mb-5" fluid>
                <Row>

                    <UserPreview></UserPreview>
                    
                    <UserData></UserData>

                </Row>
            </Container>
        </>
    );
}

export default Profile;
